import './BulletinContainer.css';
import * as React from 'react';

import { IPlaceHolder, IDocument, IPage, IBranding, IDragInfo } from '../../../../../infrastructure/interfaces';
import PageLayout from './Components/PageLayout';
import FooterLayout from './Components/FooterLayout/FooterLayout';
export interface IBulletinProps {
  document: IDocument | null;
  page: IPage;
  handleDrop(index: number, data: IPlaceHolder, dragInfo: IDragInfo): void;
  removeProduct(data: any, index: number): void;
  moveCrop(dragIndex: number, hoverIndex: number): void;
  brandings?: IBranding[];
  isEditorRendering: boolean;
  disclaimers: any[];
}

export default class BulletinContainer extends React.Component<IBulletinProps> {

  renderPage(page: IPage) {
    return (
      <PageLayout
        page={page}
        second={false}
        removeProduct={this.props.removeProduct.bind(this)}
        handleDrop={this.props.handleDrop}
        document={this.props.document}
        isEditor={this.props.isEditorRendering}
      />
    );
  }

  renderSingle(selectedPage: IPage) {
    var productCategoryWithSpaces: String = ((selectedPage != null) && (selectedPage.placeholders[0].data != null))
      ? selectedPage.placeholders[0].data.category
      : "";
    // Guard against seed products in bulletins, which have JS objects as their category
    if ((productCategoryWithSpaces == undefined) || (productCategoryWithSpaces["name"] != null)) {
      productCategoryWithSpaces = "";
    }
    const productCategory = productCategoryWithSpaces.replace(' ', '');
    return (
      <div>
        <div className={`crop-cont ${productCategory}`}>
          {this.renderPage(selectedPage)}
          <FooterLayout
            document={this.props.document}
            isEditorRendering={true}
            disclaimers={this.props.disclaimers}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      this.renderSingle(this.props.page)
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Bulletin/BulletinContainer.tsx